import qs from 'query-string';
import { NavigateToParams, openPage } from '@cap/rzmt-core';
import { isBrowser } from '@cap/ssr-common-utils';
import { UAParser } from 'ua-parser-js';
import { ENU_COURSE_TYPE } from '../course';

export const PC_PATH = {
  Home: '/web',
  CourseCenter: '/web/course-center',
  ViewAll: '/web/view-all',
  LearningHistory: '/web/learning-history',
  SearchCourses: '/web/search-courses',
  courseArticle: '/web/:tenant/article/:courseId/:tenantId',
};

export const H5_PATH = {
  Home: '/h5',
};

/**
 * 导航到应用的首页
 * @param {Object} params
 * @param {String} params.tenant 租户标识
 * @param {Object} params.query 扩展的query参数
 * @param {Function} params.onBefore 跳转到首页之前的回调函数，目标 url 作为参数传入此函数
 * @returns
 */
export async function navigatePage(path: string, params: NavigateToParams = {}) {
  if (!isBrowser) return;
  // const { hideNavbar } = getSearch();
  // eslint-disable-next-line prettier/prettier
  const { onBefore = () => {} } = params;
  const { query = {} } = params;
  // 生成目标地址
  const targetUrl = qs.stringifyUrl({
    url: path,
    query: {
      ...query,
      isFromNewHome: 'true', // 是否是新版本
    },
  });
  await onBefore(targetUrl);
  openPage(targetUrl, params);
}

export function judgeNavigatePCOrH5(projectEnv: 'pc' | 'h5') {
  const ua = new UAParser(navigator.userAgent.toLowerCase());
  const isH5Env = ua.getDevice().type === 'mobile';

  if (isH5Env && projectEnv === 'pc') {
    //  历史灰度逻辑优化，如果是在移动端打开pc网址且是课程详情页。不跳转H5首页逻辑交给useGary hooks处理
    const { pathname } = window.location;
    const isCourseDetail = !(pathname.includes(ENU_COURSE_TYPE[1]) || pathname.includes(ENU_COURSE_TYPE[2]));

    if (!isCourseDetail) return;

    navigatePage(H5_PATH.Home, { replace: true });
    return new Promise((reslove) => {
      setTimeout(() => reslove(true), 10000);
    });
  }

  if (!isH5Env && projectEnv === 'h5') {
    navigatePage(PC_PATH.Home, { replace: true });
    return new Promise((reslove) => {
      setTimeout(() => reslove(true), 10000);
    });
  }
}
